export default __webpack_public_path__ + "static/media/LogoSm.90597500.png";